export const DISCOUNT_COUPON_DISCOUNT_TYPE = {
  PERCENTAGE: "PERCENTAGE",
  AMOUNT: "AMOUNT",
};
